import {formatIsoDate} from "@/lib/utils";

/**
 * Placeholder shown for invitation fields that have no value (e.g. no current token).
 */
export const INVITATION_DATE_PLACEHOLDER = "—";

/**
 * Formats an ISO date/date-time string for an invitation field, falling back to a placeholder.
 *
 * @param {string | undefined | null} iso - The ISO date or date-time string.
 * @returns {string} The formatted "DD.MM.YYYY" date, or the placeholder when no value is present.
 */
export function formatInvitationDate(iso?: string | null): string {
    const formatted = formatIsoDate(iso);
    return formatted || INVITATION_DATE_PLACEHOLDER;
}

/**
 * Formats the "valid until" date of an invitation, appending an expiry hint when the invitation is expired.
 *
 * @param {string | undefined | null} iso - The ISO date string of the validity end.
 * @param {boolean | undefined} expired - Whether the invitation is expired.
 * @param {string} expiredLabel - The localized hint appended when expired (e.g. "abgelaufen").
 * @returns {string} The formatted date, optionally with the expiry hint, or the placeholder when no value is present.
 */
export function formatValidUntil(iso: string | undefined | null, expired: boolean | undefined, expiredLabel: string): string {
    const formatted = formatIsoDate(iso);
    if (!formatted) {
        return INVITATION_DATE_PLACEHOLDER;
    }
    return expired ? `${formatted} (${expiredLabel})` : formatted;
}
